const sendNostoCartTagging = () => {
	document.querySelectorAll('.nosto_cart:not(cart-contents .nosto_cart)').forEach(cart => cart.remove());
	if (window.nostojs) window.nostojs(api => {
		api.resendCartTagging().then(() => {
			setTimeout(() => api.loadRecommendations(), 500);
		});
	});
}

class CartContents extends HTMLElement {
	constructor() {
		super();
		this.promise = null;
		this.validating = false;
		this.hash = this.getAttribute('hash');

		const observer = new PerformanceObserver(async list => {
			if (list.getEntries().some(entry => entry.initiatorType === "fetch" && entry.name.match(/\/cart\/(add|update|change).js/))) {
				await this.promise;
				await this.update();
			}
		});

		this.addEventListener('cartupdate', e => this.update());

		observer.observe({ entryTypes: ["resource"] });

		const discountCodes = JSON.parse(this.dataset.codes || []);

		for (const code of discountCodes) {
			if (document.cookie.split(';').some(item => item.includes(`discount_code=${code}`) && !localStorage.getItem(`${code}DiscountApplied`))) {
				this.discountCode = code;
			}
		}

		this.init();

		const params = new URLSearchParams(window.location.search);
		
		if (params.get('free_gift') == 'true') {
			const freeGiftModal = document.getElementById('free-gift-modal');
			if (freeGiftModal) freeGiftModal.open({desktop: 'popup'});
		}
	}

	async update() {
		if (window.preventCartUpdate) return;
		let collapsed = [...this.querySelectorAll('.cart-item--bundle[data-collapsed="true"]')].map(item => item.dataset.bundleId);
		const summaryOpen = this.querySelector('.cart__summary.open') != null;
		
		const cartMain = this.querySelector('.cart-main');
		const cartMainScroll = cartMain ? cartMain.scrollTop : 0;
		const cartMainHeight = cartMain ? cartMain.scrollHeight : 0;
		const wasGiftUnlocked = this.querySelector('.cart__free-gift--unlocked') != null;

		const originalCount = this.querySelectorAll('.cart-item').length;

		const recs = this.querySelector('product-recommendations');
		const recsScroll = recs ? recs.querySelector('card-carousel-items').scrollLeft : 0;

		const nostoRecs = [...this.querySelectorAll('.nosto_element')];

		this.promise = fetch(`/?section_id=cart`);
		let resp = await this.promise;
		let parser = new DOMParser();
		let doc = parser.parseFromString(await resp.text(), 'text/html');

		const newContents = doc.querySelector('cart-contents');

		// Only update if cart items have changed
		const newHash = newContents.getAttribute('hash');
		if (newHash == this.hash) return;
		else this.hash = newHash;

		this.replaceChildren(...newContents.children); 

		for (const attr of newContents.attributes) {
			if (attr.name != 'hash') this.setAttribute(attr.name, attr.value);
		}

		if (this.offsetParent != null) sendNostoCartTagging();

		for (let item of this.querySelectorAll('.cart-item--bundle')) {
			if (collapsed.includes(item.dataset.bundleId)) item.toggleCollapse(false);
		}

		let updatedCartMain = this.querySelector('.cart-main');
		let countElem = document.querySelector('.site-header__cart .cart-count');
		
		if (updatedCartMain) {
			updatedCartMain.scrollTop = cartMainScroll + (updatedCartMain.scrollHeight - cartMainHeight);

			let count = parseInt(this.querySelector('.cart-items').dataset.count);

			countElem.innerHTML = count;
			countElem.style.display = '';

			if (summaryOpen) {
				const summary = this.querySelector('.cart__summary');
				summary.classList.add('open');
			}
		}
		else countElem.style.display = 'none';

		const newRecs = this.querySelector('product-recommendations');
		if (recs && newRecs) {
			newRecs.querySelector('card-carousel-items').scrollLeft = recsScroll;
			newRecs.addEventListener('loaded', e => {
				console.log('Set scroll to', recsScroll)
				newRecs.querySelector('card-carousel-items').scrollLeft = recsScroll;
			});
		}

		for (const rec of nostoRecs) {
			const newRec = this.querySelector(`#${rec.id}`);
			if (newRec) newRec.replaceWith(rec);
		}

		const newCount = this.querySelectorAll('.cart-item').length;
		if (newCount > originalCount && !!( this.offsetWidth || this.offsetHeight || this.getClientRects().length )) {
			updatedCartMain.scrollTo({ top: 0, behavior: 'smooth' });
		}

		const isGiftUnlocked = this.querySelector('.cart__free-gift--unlocked') != null;
		if (!wasGiftUnlocked && isGiftUnlocked) {
			updatedCartMain.scrollTo({ top: 0, behavior: 'smooth' });
		}

		this.init();
	}

	async validateCart() {
		if (this.validating) return;
		this.validating = true;

		const resp = await fetch('/cart.js');
		const json = await resp.json();
		const items = json.items;

		document.documentElement.classList.toggle('cart-empty', items.length == 0);

		// Validate bundles
		for (const item of items) {
			if (item.price === 0 && !item.properties['_ParentPrice'] && (item.sku.startsWith('BND') || item.sku.includes('FLSS'))) {
				this.dataset.validating = "true";
				const resp = await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: item.key,
						quantity: 0
					})
				});

				if (resp.ok) {
					await addToCartGlobal(item.handle, item.variant_id, item.quantity, true);
				}
			}
		}

		// Remove lone child items
		for (const item of items) {
			const childId = item.properties['_BundleId'];
			if (childId && item.properties['_PartOf'] && !items.some(i => i.key != item.key && i.properties['_BundleId'] == childId)) {
				this.dataset.validating = "true";
				const resp = await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: item.key,
						quantity: 0
					})
				});
			}
		}

		const giftCardsTotal = items.filter(item => item.vendor == 'Giftnote').reduce((acc, item) => acc + item.final_line_price, 0);
		const adjustedTotalPrice = json.total_price - giftCardsTotal;

		// Validate free gifts
		const gifts = items.filter(item => theme.freeGift.products.includes(item.handle));
		const giftCount = gifts.reduce((acc, item) => acc + item.quantity, 0);

		if (giftCount > 0) {
			let updates = null;
			
			if (!theme.loggedIn || !theme.freeGift.eligible || theme.freeGift.redeemed) {
				updates = Object.fromEntries(
					gifts.map(gift =>  [gift.key, 0])
				);
			}
			else if (giftCount > 1) {
				updates = Object.fromEntries(
					gifts.map((gift, idx) =>  [gift.key, idx == gifts.length - 1 ? 1 : 0])
				)
			}

			if (updates) {
				this.dataset.validating = "true";

				await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ updates })
				});
			}
		}

		// Add automatic gift
		const giftThreshold = parseFloat(this.getAttribute('automatic-gift-threshold'));
			
		if (!Number.isNaN(giftThreshold) && adjustedTotalPrice >= giftThreshold) {
			document.documentElement.classList.add('gift-unlocked');

			if (this.hasAttribute('automatic-gift') && !items.some(item => item.properties['_AutomaticGift'] == true) && !json.attributes['_RemovedGift']) {
				this.dataset.validating = "true";
				await this.addFreeGift(this.getAttribute('automatic-gift'), giftThreshold, true);
			}
		}
		else document.documentElement.classList.remove('gift-unlocked');

		// Validate and add BXGY
		if (this.hasAttribute('bxgy-targets')) {
			const targetProductIds = this.getAttribute('bxgy-targets').split(',').map(id => parseInt(id));
			const giftVariantId = parseInt(this.getAttribute('bxgy-gift'));

			const targetCount = items.filter(item => targetProductIds.includes(item.product_id)).reduce((acc, item) => acc + item.quantity, 0);
			const giftCount = items.filter(item => item.variant_id == giftVariantId && item.final_price == 0).reduce((acc, item) => acc + item.quantity, 0);
		
			const giftsToAdd = targetCount - giftCount;

			if (giftsToAdd < 0) {
				this.dataset.validating = "true";
				const giftItem = items.find(item => item.variant_id == giftVariantId && item.final_price == 0);

				await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						updates: {
							[giftItem.key]: giftItem.quantity + giftsToAdd
						}
					})
				});
			}
		}
		else {
			const bxgyItems = items.filter(item => item.properties['_BXGY'] == true);
			if (bxgyItems.length > 0) {
				const updates = Object.fromEntries(bxgyItems.map(item => [item.key, 0]));
				this.dataset.validating = "true";

				await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ updates })
				});
			}
		}
		
		// Validate free gifts over $X, remove duplicates or those where threshold is under total
		const freeGifts = items.filter(item => item.properties['_FreeGift'] == true && item.properties['_FreeGiftThreshold']);
		const toRemove = freeGifts.filter(item => item.properties['_FreeGiftThreshold'] > adjustedTotalPrice || freeGifts.indexOf(item) > 0);
		if (toRemove.length > 0) {
			const updates = Object.fromEntries(toRemove.map(item => [item.key, 0]));
			this.dataset.validating = "true";
			await fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ updates })
			});
		}

		this.dataset.validating = "false";
		this.validating = false;
	} 

	init() {
		if (this.discountCode) {
			const code = this.discountCode;

			this.querySelector('a.checkout').addEventListener('click', () => {
				localStorage.setItem(`${code}DiscountApplied`, 'true');
			});

			this.querySelectorAll(`[data-code="${code}"]`).forEach(elem => elem.style.display = '');
			this.querySelector('.cart-footer__total--regular').style.display = 'none';

			if (sessionStorage.getItem(`${code}DiscountAcknowledged`) != 'true') {
				const popup = this.querySelector(`.cart__discount-popup[data-code="${code}"]`);
				
				if (popup) {
					popup.classList.add('active');
					
					popup.querySelector('button').addEventListener('click', () => {
						popup.classList.remove('active');
						popup.classList.add('transition-out');
						setTimeout(() => popup.classList.remove('transition-out'), 300);
						sessionStorage.setItem(`${code}DiscountAcknowledged`, 'true');
					});
				}
			}
		}

		const continueButton = this.querySelector('.cart__continue');
		if (continueButton) continueButton.addEventListener('click', e => this.dispatchEvent(new CustomEvent('continue', { bubbles: true })));

		const summary = this.querySelector('.cart__summary');
		if (summary) {
			summary.querySelector('.cart__summary-short').addEventListener('click', e => {
				summary.style.setProperty('--height', `${summary.scrollHeight}px`);
				summary.classList.toggle('open');
			});
		}

		this.querySelector('.cart__free-gift-atc')?.addEventListener('click', e => {
			e.currentTarget.classList.add('show-loading');
			this.addFreeGift(e.target.dataset.id, e.target.dataset.threshold, e.target.dataset.automatic == 'true');
		});

		this.querySelector('.cart__bxgy-atc')?.addEventListener('click', async e => {
			e.currentTarget.classList.add('show-loading', 'show-loading--inverted');

			await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					items: [{ 
						id: e.target.dataset.variantId, 
						quantity: parseInt(e.target.dataset.count), 
						properties: {
							_FreeGift: true,
							_BXGY: true
						} 
					}]
				})
			});
		});

		this.validateCart();
	}

	async addFreeGift(id, threshold, automatic = false) {
		await fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				items: [{ 
					id: id, 
					quantity: 1, 
					properties: {
						_AutomaticGift: automatic ? true : undefined,
						_FreeGift: true,
						_FreeGiftThreshold: threshold
					} 
				}]
			})
		});

		this.dataset.giftAdded = 'true';
		setTimeout(() => this.dataset.giftAdded = 'false', 3000);
	}
}

class CartItem extends HTMLElement {
	constructor() {
		super();

		let remove = this.querySelector('button[name="remove"]');
		if (remove) {
			remove.addEventListener('click', async e => {
				e.currentTarget.classList.add('show-loading');
				await this.setQuantity(0);
			});
		}

		let increase =	this.querySelector('button[name="increase"]');
		if (increase) {
			increase.addEventListener('click', async e => {
				this.querySelector('.cart-item__quantity-selector').classList.add('show-loading');
				await this.setQuantity(parseInt(this.dataset.quantity) + 1);
			});
		}

		let decrease = this.querySelector('button[name="decrease"]');
		if (decrease) {
			decrease.addEventListener('click', async e => {
				this.querySelector('.cart-item__quantity-selector').classList.add('show-loading');
				await this.setQuantity(Math.max(0, parseInt(this.dataset.quantity) - 1));
			});
		}

		if (this.dataset.bundleId) {
			this.bundleItems = [...this.closest('.cart-items').querySelectorAll(`.cart-item:not(.cart-item--bundle)[data-bundle-id="${this.dataset.bundleId}"]`)];
			let bundleItemsElem = this.closest('.cart-items').querySelector(`.cart-items__bundle-items[data-bundle-id="${this.dataset.bundleId}"]`);
			
			if (bundleItemsElem) {
				bundleItemsElem.style.setProperty('--items', this.bundleItems.length);
				let collapse = this.querySelector('button[name="collapse"]');
				if (collapse) collapse.addEventListener('click', e => this.toggleCollapse());
			}
		}
	}

	toggleCollapse(animate = true) {
		let bundleItemsElem = this.closest('.cart-items').querySelector(`.cart-items__bundle-items[data-bundle-id="${this.dataset.bundleId}"]`);
		let collapse = this.querySelector('button[name="collapse"]');
		bundleItemsElem.style.setProperty('--items', this.bundleItems.length);

		if (!animate) bundleItemsElem.classList.remove('animate');
		else bundleItemsElem.classList.add('animate');

		if (this.dataset.collapsed == 'true') {
			this.dataset.collapsed = 'false';
			bundleItemsElem.classList.remove('collapsed');
			collapse.querySelector('span').innerHTML = 'Hide';
		}
		else {
			this.dataset.collapsed = 'true';
			bundleItemsElem.classList.add('collapsed');
			collapse.querySelector('span').innerHTML = 'Show';
		}
	}

	async setQuantity(quantity) {
		const quantityElem = this.querySelector('.cart-item__quantity');
		if (quantityElem) quantityElem.innerHTML = quantity;

		const attributes = {};
		if ((this.dataset.type == 'automatic-gift' || this.dataset.type == 'bxgy') && quantity == 0) attributes['_RemovedGift'] = true;

		const updates = {};
		updates[this.dataset.key] = quantity;
		if (this.dataset.linkedKey) updates[this.dataset.linkedKey] = quantity;

		let resp = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				updates,
				attributes
			})
		});

		if (resp.ok) {
			return true;
		}

		return false;
	}
}

class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.querySelector('.cart-drawer__bg').addEventListener('click', e => this.hide());
		this.querySelector('button[name="close"]').addEventListener('click', e => this.hide());
		
		document.querySelector('.site-header__cart').addEventListener('click', e => {
			e.preventDefault();
			this.show();
		});

		this.addEventListener('continue', e => this.hide());

		const params = new URLSearchParams(window.location.search);
		if (params.get('open_cart') == 'true') this.show();
	}

	async connectedCallback() {
		window.updateCartDrawer = async () => {
			await this.querySelector('cart-contents').promise;
		}

		window.showCartDrawer = (force = false) => {
			if (force || document.body.classList.contains('has-furniture')) {
				this.show();
			} else {
				if ((theme.storeLocation == 'US' || theme.storeLocation == 'UK' || window.innerWidth < 993) && !document.querySelector('body.template-collection')) {
					window.activateSignifier();
				} else {
					try {
						window.showUpsell()
					} catch (error) {}
				}
			}
		}

		const cartSection = this.querySelector('#shopify-section-cart');
		if (!cartSection) {
			const resp = await fetch('/?section_id=cart');
			const html = await resp.text();
			this.querySelector('.cart-drawer__contents').insertAdjacentHTML('afterbegin', html);
		}
	}

	show() {
		if (!this.classList.contains('open')) {
			document.documentElement.classList.add('cart-active');
			document.body.style.overflowY = 'hidden';
			this.classList.add('open', 'transition-in');
			sendNostoCartTagging();
			setTimeout(() => this.classList.remove('transition-in'), 300);
		}
	}

	hide() {
		if (this.classList.contains('open')) {
			this.classList.add('transition-out');
			setTimeout(() => {
				document.documentElement.classList.remove('cart-active');
				document.body.style.overflowY = '';
				this.classList.remove('open', 'transition-out');
			}, 300);
		}
	}
}

if (!customElements.get('cart-contents')) customElements.define('cart-contents', CartContents);
if (!customElements.get('cart-item')) customElements.define('cart-item', CartItem);
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);